(function() { window.GUID_035557a9_899d_4ba8_9266_b11b95ca3abf = { getGuid: function() { return "035557a9-899d-4ba8-9266-b11b95ca3abf"; } }; })();
var MasterPage;
(function (MasterPage) {
    MasterPage.MasterSearch = $("#MasterSearch");
    var MasterSearchHidden = $("#TxtMasterSearch", MasterPage.MasterSearch);
    MasterPage.TxtMasterSearch = $("#TxtMasterSearchAutoComplete", MasterPage.MasterSearch);
    var imgMasterSearch = $("#ImgMasterSearch", MasterPage.MasterSearch);
    var MasterContainer = $("#MasterContainer");
    var HintSection = $("#HintSection");
    MasterPage.HintContent = $("#HintSectionContent");
    var HintClose = $("#HintSectionClose");
    if (currentHintName != null &&
        currentHintName != undefined &&
        MasterPage.HintContent != null &&
        MasterPage.HintContent.length > 0 &&
        MasterPage.HintContent[0].innerHTML != "") {
        ShowHintSection(currentHintName);
    }
    imgMasterSearch.on("click", function (e) {
        MasterPage.MasterSearch.trigger("CSMasterSearch");
    });
    MasterPage.MasterSearch.on("CSChange", function () {
        MasterPage.MasterSearch.trigger("CSMasterSearch");
    });
    MasterPage.TxtMasterSearch.on("keyup", function (e) {
        var key = window.event ? e.keyCode : e.which;
        if (key == 13) {
            e.stopPropagation();
            MasterPage.MasterSearch.trigger("CSMasterSearch");
        }
    });
    MasterPage.TxtMasterSearch.on("CSClear", function () {
        MasterSearchHidden.val(null);
        MasterPage.MasterSearch.trigger("CSMasterSearch");
    });
    MasterPage.TxtMasterSearch.val = function (value) {
        if (value != undefined) {
            MasterPage.TxtMasterSearch[0].value = value;
        }
        else {
            if (MasterPage.TxtMasterSearch.hasClass("watermark")) {
                return "";
            }
            else {
                if (MasterPage.TxtMasterSearch.length > 0) {
                    return MasterPage.TxtMasterSearch[0].value;
                }
                else {
                    return "";
                }
            }
        }
    };
    MasterPage.MasterSearch.val = function (value) {
        if (value != undefined) {
            MasterSearchHidden.val(value);
        }
        else {
            return MasterSearchHidden.val();
        }
    };
    MasterPage.MasterSearch.context = function () {
        return MasterSearchHidden.data("context").SelectedElement;
    };
    CheckIfBackClicked();
    function CheckIfBackClicked() {
        var tickVerif = $("#TickVerificator");
        if (tickVerif.length == 0) {
            return;
        }
        var actualTickVerificator = tickVerif.val();
        var lastTickCookie = GetCookieValue(0, "TickVerificator");
        var lastUrlCookie = GetCookieValue(0, "LastUrlVerificator");
        SetCookieValue(0, "TickVerificator", actualTickVerificator);
        SetCookieValue(0, "LastUrlVerificator", window.location.pathname);
        var data = {
            lastUrl: window.location.pathname,
        };
        if (lastTickCookie != null) {
            if (lastUrlCookie != data.lastUrl) {
                if (lastTickCookie > actualTickVerificator) {
                    // delegateBackClicked est déclaré au début du body de MasterPage
                    if (delegateBackClicked != null) {
                        delegateBackClicked.call();
                        return;
                    }
                    var randomValue = RandomBetweenRange(1000000000, 9999999999).toString();
                    var href = window.location.href;
                    if (href.indexOf("?") == -1) {
                        href += "?";
                    }
                    var startTag = "&frId=";
                    var endTag = "endfrld";
                    var indexOfForceReload = href.indexOf(startTag);
                    var indexOfEndForceReload = href.indexOf(endTag) + endTag.length;
                    if (indexOfForceReload > -1) {
                        var forceReloadPart = href.substr(indexOfForceReload, indexOfEndForceReload - indexOfForceReload);
                        href = href.replace(forceReloadPart, "");
                    }
                    href += startTag + randomValue + endTag;
                    window.location.replace(href);
                }
            }
        }
    }
    function RandomBetweenRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    var masterContainerStartPositon = null;
    function ShowHintSection(hintName) {
        currentHintName = hintName;
        HintSection.slideDown(300, function () {
            MakeRoomForHintSection();
        });
        CS.win.on("resize.hint", MakeRoomForHintSection);
    }
    MasterPage.ShowHintSection = ShowHintSection;
    var timer = null;
    function MakeRoomForHintSection() {
        clearTimeout(timer);
        timer = setTimeout(function () {
            var hintHeight = HintSection[0].scrollHeight;
            if (masterContainerStartPositon == null) {
                masterContainerStartPositon = MasterContainer.css("top");
                if (masterContainerStartPositon != null) {
                    masterContainerStartPositon = parseFloat(masterContainerStartPositon.replace("px", ""));
                }
                else {
                    masterContainerStartPositon = 0;
                }
            }
            MasterContainer.animate({ top: masterContainerStartPositon + hintHeight + 10 }, 300);
            Menu.PushMenuDownForHintMessage(hintHeight);
        }, 200);
    }
    function HideHintSection() {
        if (currentHintName != null &&
            currentHintName != "" &&
            CSParameters.IsConnected) {
            var data = {
                hintName: currentHintName,
            };
            CompuSport.Ajax.Post(CSParameters.BaseUrl +
                "Account/IncrementUserHintCount/" +
                CSParameters.SportEventId, data, function (queryResult) { });
        }
        HintSection.slideUp(300);
        MasterContainer.animate({ top: masterContainerStartPositon }, 300);
        Menu.PullMenuUpForHintMessage();
        CS.win.off("resize.hint");
    }
    HintClose.on("click", HideHintSection);
    /*Bon pour tester le hint nimporte ou*/
    //$(function () {
    //    HintContent.text('Click on Follow below to receive push notifications');
    //    ShowHintSection('Notification.Follow');
    //})
    $("#MasterHeader").css({
        height: "inherit",
        overflow: "inherit",
    });
    function setKendoCulture() {
        try {
            if (typeof window.kendo === "undefined") {
                throw new Error("Kendo is not loaded");
            }
            const langCode = CSParameters.Language;
            switch (langCode.toLowerCase()) {
                case "fr":
                    if (window.setKendoCultureToFrench) {
                        window.setKendoCultureToFrench();
                    }
                    break;
                case "es":
                    if (window.setKendoCultureToSpanish) {
                        window.setKendoCultureToSpanish();
                    }
                    break;
                case "fi":
                    if (window.setKendoCultureToFinnish) {
                        window.setKendoCultureToFinnish();
                    }
                    break;
                case "da":
                    if (window.setKendoCultureToDanish) {
                        window.setKendoCultureToDanish();
                    }
                    break;
                case "en":
                default:
                    if (window.setKendoCultureToEnglish) {
                        window.setKendoCultureToEnglish();
                    }
                    break;
            }
        }
        catch (error) {
            console.error("Error while setting kendo culture", error);
        }
    }
    function HideSnackbar(props) {
        const $snackbar = $(`#${props.id}`);
        if ($snackbar.length > 0) {
            $snackbar.animate({ opacity: 0 }, 300, () => {
                $snackbar.remove();
                if (props.callback) {
                    props.callback.call(this);
                }
            });
        }
    }
    MasterPage.HideSnackbar = HideSnackbar;
    function showSnackbar(props) {
        let containerCssClass = "snackbar-container";
        let contentCssClass = "snackbar";
        let txtCssClass = "snackbar__txt";
        let closeIconCssClass = "snackbar__close-icon icon ic-cs-times";
        switch (props.type) {
            case "error":
                contentCssClass += " snackbar__danger";
                break;
            case "info":
                contentCssClass += " snackbar__info";
                break;
            case "success":
                contentCssClass += " snackbar__success";
                break;
            default:
                break;
        }
        const $snackbar = $(`
    <div id="${props.id}" class="${containerCssClass}" style="margin-bottom: 16px;">
      <div class="${contentCssClass}">
        <div class="${txtCssClass}">${props.content}</div>
        <div class="${closeIconCssClass}"></div>
      </div>
    </div>`);
        $("#MasterBody").append($snackbar);
        const autoHideDuration = 5000;
        $snackbar.animate({ opacity: 1 }, 300, () => {
            $snackbar.find(".snackbar").addClass("show");
            if (autoHideDuration) {
                setTimeout(() => {
                    HideSnackbar({ id: props.id });
                }, autoHideDuration);
            }
        });
        $snackbar.on("click", () => {
            HideSnackbar({ id: props.id });
        });
    }
    function ShowSnackbar(props) {
        const $previousSnackbar = $(".snackbar-container").last();
        const previousSnackbarId = $previousSnackbar.attr("id");
        if (previousSnackbarId) {
            HideSnackbar({
                id: previousSnackbarId,
                callback: () => {
                    showSnackbar(props);
                },
            });
        }
        else {
            showSnackbar(props);
        }
    }
    MasterPage.ShowSnackbar = ShowSnackbar;
    window.onload = function () {
        let title_var = document.title;
        document.title = title_var;
        setKendoCulture();
    };
})(MasterPage || (MasterPage = {}));

//# sourceMappingURL=MasterPage.js.map
